export default {
  pageTitle: 'Time and Attendance',
  pageTitleJobsReport: 'Jobs',
  filters: {
    search: 'Search',
    placeholder: 'Wonoloer Name or Job Name',
    placeholderV2: 'Wonoloer or job name',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    invoiceIds: 'Invoice ID'
  },
  quickReports: {
    label: 'Quick Reports',
    roster: 'Roster',
    default: 'Time and Attendance',
    invoicing: 'Invoicing'
  },
  export: 'Export CSV',
  exportModalTitle: 'Large Jobs Report export',
  exportModalText: "We'll email you a link to the report when it's ready",
  customizeReport: 'Customize Report',
  customizeReportForm: {
    selectAll: 'Select All',
    cancel: 'Cancel',
    apply: 'Apply'
  },
  exportToExcel: 'Export to Excel',
  exportToCsv: 'Export to CSV',
  cell: {
    actions: {
      adjust: 'Adjust',
      details: 'Details'
    },
    wonoloerName: 'Wonoloer Name',
    jobName: 'Job Name',
    date: 'Date',
    postedTime: 'Posted Time',
    actualTime: 'Logged Time',
    jobStates: {
      flexible_filled: 'Filled Flexible',
      filled: 'Upcoming',
      in_progress: 'In Progress',
      paused: 'Paused',
      no_show: 'No Show',
      withdrawn: 'Withdrawn',
      cancelled: 'Cancelled',
      invited: 'Invited',
      rejected: 'Rejected',
      completed: 'Completed',
      approved: 'Approved',
    }
  },
  cellV2: {
    billedAmount: 'Billed Amount',
    transactionDate: 'Transaction Date',
    invoiceId: 'Invoice ID',
    bonusJob: 'Bonus Job',
    worker: 'Wonoloer',
    state: 'State',
    status: 'Status',
    startedDate: 'Started Date',
    startDate: 'Start Date',
    completeDate: 'Completed Date',
    approvedAt: 'Approved Date',
    jobId: 'Job ID',
    requestName: 'Job Name',
    jobCode: 'Job Code',
    jobPoster: 'Job Owner',
    address: 'Address',
    venue: 'Location',
    cityAndRegion: 'City & State',
    originalClockInAt: 'Original Clock In',
    originalClockOutAt: 'Original Clock Out',
    scheduledTime: 'Scheduled Time',
    scheduledStartTime: 'Scheduled Start Time',
    scheduledEndTime: 'Scheduled End Time',
    scheduledUnpaidBreak: 'Scheduled Unpaid Break',
    scheduledHours: 'Scheduled Hours',
    clockIn: 'Clock In',
    clockOut: 'Clock Out',
    unpaidBreak: 'Unpaid Break',
    hoursWorked: 'Hours Worked',
    verificationClockIn: 'Verification (Clock In)',
    verificationClockOut: 'Verification (Clock Out)',
    allowExtraTime: 'Allowed Extra Time',
    extraTimeApprover: 'Extra Time Allowed By',
    autoClockedOut: 'Auto Clock-out',
    hourlyRate: 'Hourly Rate',
    hourlyCost: 'Hourly Cost',
    flatRate: 'Flat Rate',
    coveredCosts: 'Covered Costs',
    coveredCostsNote: 'Covered Costs Note',
    wonoloerPay: 'Wonoloer Pay',
    serviceCharge: 'Service Charge',
    totalCost: 'Total Cost',
    adjustments: 'Adjustments',
    imagePopup: 'Wanda',
    mapPopup: 'Wonoloer App',
    unknown: 'Unknown',
    workerStatus: 'Status',
    excusedAbsenceReason: 'Excused Absence Reason',
  },
  wandaPopUp: {
    noImage: 'No Image Available',
    noInfo: 'No clock in/out information provided',
    clockIn: 'Clock-In',
    clockOut: 'Clock-Out'
  },
  modal: {
    exportOptionsTitle: 'Export Attendance Report',
    exportOptionsContent: 'Export a report for %startDate% to %endDate%',
    exportOptionsContentExcel:
      'Export an Excel document for usage with Microsoft Excel',
    exportOptionsContentCSV:
      'Export a CSV to import raw data into other tools or worksheets',
    exportExcel: 'Export Excel',
    exportCSV: 'Export CSV',
    exportModalName: 'Export Attendance Modal'
  },
  attendanceTable: {
    noResults: 'No results found',
    emptyTip: 'Try different keywords or expanding your date range.'
  }
};
